import React from 'react';
import { render } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};

render(<App {...props} />, document.getElementById('root'));
initDimensionsFromState(props);

trackInitialPageView(props.gaSettings);
